export default class ClipboardService {
  /** @ngInject **/
  constructor(
  ) {
    this.supported = 'queryCommandSupported' in document && document.queryCommandSupported('copy');
  }

  copyText(text, context) {
    const node = this.#createNode(text, context);
    document.body.appendChild(node);
    this.#copyNode(node);
    document.body.removeChild(node);
  }

  #createNode(text) {
    const node = document.createElement('textarea');
    node.style.position = 'absolute';
    node.textContent = text;
    node.style.left = '-10000px';
    node.style.top = (window.pageYOffset || document.documentElement.scrollTop) + 'px';
    return node;
  }

  #copyNode(node) {
    try {
      // Set inline style to override css styles
      document.body.style.webkitUserSelect = 'initial';

      const selection = document.getSelection();
      selection.removeAllRanges();
      node.select();

      if(!document.execCommand('copy')) {
        throw new Error('failure copy');
      }
      selection.removeAllRanges();
    } finally {
      // Reset inline style
      document.body.style.webkitUserSelect = '';
    }
  }
}
